import React from 'react';

const OrganizationSchema = ({ 
  name = 'Water Damage Direct',
  url = 'https://www.waterdamagedirect.com',
  logo = 'https://www.waterdamagedirect.com/images/logo.png',
  description = 'Emergency water damage restoration services connecting homeowners with trusted local professionals.',
  socialLinks = []
}) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": name,
    "url": url,
    "logo": logo,
    "description": description
  };

  // Add social media links if provided
  if (socialLinks && socialLinks.length > 0) {
    schemaData.sameAs = socialLinks;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
};

export default OrganizationSchema;